import { app } from '../../../../app';

app.component('confirmDeleteSaaspassConnect', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-delete-sasspass-connect.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/confirm-delete-sasspass-connect/confirm-delete-sasspass-connect.component.js